var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromptArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67011 12.0002H4.10096M4.10096 12.0002L2.85151 17.9489C2.50757 19.5864 4.20665 20.8972 5.70323 20.1489L18.4229 13.789C19.897 13.052 19.897 10.9484 18.4229 10.2113L17.5006 9.75019M4.10096 12.0002L2.85151 6.05146C2.50757 4.41396 4.20664 3.10321 5.70323 3.85151L8.00059 5.00019",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7257 5.47059C12.4453 4.84314 11.5547 4.84313 11.2743 5.47059L10.7173 6.71727L9.47059 7.2743C8.84314 7.55466 8.84314 8.44534 9.47059 8.7257L10.7173 9.28273L11.2743 10.5294C11.5547 11.1569 12.4453 11.1569 12.7257 10.5294L13.2827 9.28273L14.5294 8.7257C15.1569 8.44534 15.1569 7.55466 14.5294 7.2743L13.2827 6.71727L12.7257 5.47059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4838 3.31373C18.2969 2.89542 17.7031 2.89542 17.5162 3.31373L17.1448 4.14485L16.3137 4.5162C15.8954 4.7031 15.8954 5.2969 16.3137 5.4838L17.1448 5.85515L17.5162 6.68627C17.7031 7.10458 18.2969 7.10458 18.4838 6.68627L18.8552 5.85515L19.6863 5.4838C20.1046 5.2969 20.1046 4.7031 19.6863 4.5162L18.8552 4.14485L18.4838 3.31373Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptArrowIcon);
export default __webpack_public_path__ + "static/media/promptArrowIcon.d22295471746732da6ff77e6d0b084a0.svg";
export { ForwardRef as ReactComponent };